/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import { MDBFile } from 'mdb-react-ui-kit';
import { isTokenPresent } from '../utils/auth';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiGLPIRoutes from '../utils/hooks/apiGLPIRoutes';
import apiRoutes from '../utils/hooks/apiRoutes';
import DocumentData from '../utils/Interface/DocumentData';
import Button from './Button';
import "../style/css/upload.css"


interface EditDocumentProps {
  documentId: number; 
  user_name: string;
  user_id: number;
  modelDocName: string;
}

function UploadSignedDocuments({ documentId, user_name, user_id, modelDocName }: EditDocumentProps) {
  const [dataOne, setDataOne] = useState<DocumentData | null>(null);
  const [documentSelectedName, setDocumentSelectedName] = useState<string>('');
  const [newDoc, setNewDoc] = useState<File | null>(null); 
  const { specialToken } = useSpecialToken();
  const token = localStorage.getItem("sessionToken") || "";

  const fetchDataOne = async (): Promise<void> => {

    try {
      if (!documentId) {
        throw new Error('ID de document non valide');
      }
  
      const getOneUrl = apiRoutes.documentsGetOne.replace(':id', `${documentId}`);
  
      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }
  
      const headers = {
        'Content-Type': 'application/json',
        'special-token': specialToken
      };
  
      const response = await fetch(getOneUrl, { headers });
  
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }
  
      const jsonDataOne: DocumentData = await response.json();
  
      setDataOne(jsonDataOne);
      setDocumentSelectedName(jsonDataOne.document_name);
  
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }

  };

  useEffect(() => 

    {
    if (!isTokenPresent()) {
      window.location.href = '/'; // Redirection vers la page de connexion
      return;
    } 

    if (documentId) {
      fetchDataOne();
    }
  }, [documentId, specialToken]);

  const handleSavePut = async (): Promise<void> => {

    if (!newDoc || !specialToken) {
        return;
    }

    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Les mois vont de 0 à 11, donc +1
    const year = currentDate.getFullYear();
    const date = `${day}${month}${year}`;
    const formData = new FormData();
    formData.append('uploadManifest', JSON.stringify({
        input: {
            name: `doc_${date}-${user_name}_signed`,
            _filename: `doc_${date}-${user_name}_signed.pdf`,
            state: 'Signé',
            glpi_user_id: user_id,
            documents_modeles_name: modelDocName,
        }
    }));
    formData.append('filename', newDoc, `doc_${date}-${user_name}_signed.pdf`);


    const responseGLPI = await fetch(apiGLPIRoutes.documentPostOne, {
        method: 'POST',
        headers: {
            'Session-Token': token, 
        },
        body: formData
    });

    if (!responseGLPI.ok) {
        const errorText = await responseGLPI.text(); // Lire le corps de la réponse pour obtenir des détails sur l'erreur
        console.error('Erreur lors de l\'envoi du document à l\'API GLPI:', responseGLPI.status, responseGLPI.statusText, errorText);
        throw new Error(`Erreur lors de l'envoi du document à l'API GLPI: ${responseGLPI.status} ${responseGLPI.statusText} - ${errorText}`);
    }


  const deleteDocUrl = apiGLPIRoutes.documentGetOne.replace(':documentId', `${documentId}`)

    const responseGLPI2 = await fetch(deleteDocUrl, {
      method: 'DELETE',
      headers: {
          'Session-Token': token, 
      }
    });

   if (!responseGLPI2.ok) {
      const errorText = await responseGLPI.text(); // Lire le corps de la réponse pour obtenir des détails sur l'erreur
      console.error('Erreur lors de la suprresiond du document par  GLPI:', responseGLPI.status, responseGLPI.statusText, errorText);
      throw new Error(`Erreur lors de la suppression du document par  GLPI: ${responseGLPI.status} ${responseGLPI.statusText} - ${errorText}`);
    } else {
    }

    alert('Document signé ajouté avec succès !')

    window.location.reload();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      setNewDoc(files[0]);

    }
  };

  return (

    <div className='uploaddoc'>

      <div className='uploaddoc__box1'>

        <h4 className='uploaddoc__box1__title'>{documentSelectedName}</h4>

        <div className='uploaddoc__box1__container'>

          <MDBFile
            label='+ Ajouter le document signé ici'
            labelClass="uploaddoc__box1__container__label"
            size='lg'
            id=''
            onChange={handleFileChange}
          />

        </div>

      </div>

      <div className='uploaddoc__box2'>

        <Button btnName={'Sauvegarder'} onClick={handleSavePut} disable={false} />

        <Button btnName={'Annuler'} onClick={()=>console.log("click")} disable={false}/>

      </div>

    </div>
    
  );
}

export default UploadSignedDocuments;
